class PredictiveSearch extends HTMLElement{
	constructor() {
      super()
      this.cachedResults={}
      this.input=this.querySelector("input[type='search']")
      this.predictiveSearchResults=this.querySelector(".ss-section-wrapper")
      this.smartSearchSection=this.querySelector(".dbtfy-smart_search")
      this.limit=this.smartSearchSection.dataset.limit
      this.resourcesType=this.smartSearchSection.dataset.resourcesType
      this.input.setAttribute("autocomplete","off")
      this.setupEventListeners()
	}

    setupEventListeners() {
      this.querySelector("form.search-bar").addEventListener("submit",this.onFormSubmit.bind(this))
      this.input.addEventListener("input", theme.debounce(e=>{this.onChange(e)},300).bind(this))
      this.input.addEventListener("focus",this.onFocus.bind(this))
      this.addEventListener("focusout",this.onFocusOut.bind(this))
      this.addEventListener("keyup",this.onKeyup.bind(this))
      this.addEventListener("keydown",this.onKeydown.bind(this))
	}
  
  	getQuery() {
		return this.input.value.trim()
	}
  
	onChange() {
		const e=this.getQuery();
        e.length?this.getSearchResults(e):this.close(!0)
	}
  
	onFormSubmit(e){
		this.getQuery().length&&!this.querySelector(".item-selected a")||e.preventDefault()
	}
  
	onFocus(){
		const e=this.getQuery();e.length&&("true"===this.getAttribute("results")?this.open():this.getSearchResults(e))
	}
  
	onFocusOut(){
		setTimeout(()=>{this.contains(document.activeElement)||this.close()})
	}
  
	onKeyup(e){
		switch(this.getQuery().length||this.close(!0),
		e.preventDefault(),
		e.code){case"ArrowUp":this.switchOption("up");break;case"ArrowDown":this.switchOption("down");break;case"Enter":this.selectOption()}
    }
  
	onKeydown(e){
		"ArrowUp"!==e.code&&"ArrowDown"!==e.code||e.preventDefault()
	}

    switchOption(e){
    	if(!this.getAttribute("open"))return;const t="up"===e,
    	s=this.querySelector(".item-selected"),
    	i=Array.from(this.querySelectorAll(".ss-item"));
    	let r=i[0];
    	if(t&&!s)return;
    	const n=s?i.indexOf(s):0;
    	!t&&s?r=i[n+1]||i[0]:t&&(r=i[n-1]||i[i.length-1]),
    	r!==s&&(r.classList.add("item-selected"),
    	s&&s.classList.remove("item-selected"),
    	this.input.setAttribute("aria-activedescendant",r.id))
    } 
  
    selectOption() {
        const e=this.querySelector(".item-selected a, .item-selected button");
        e&&e.click()
    }
  
    getSearchResults(e){	
		const t=e.replace(" ","-").toLowerCase();
		this.cachedResults[t]?this.renderSearchResults(this.cachedResults[t]):fetch(`/search?q=${encodeURIComponent(e)}&${encodeURIComponent("resources[type]")}=${this.resourcesType}&${encodeURIComponent("resources[limit]")}=${this.limit}&${encodeURIComponent("resources[options][unavailable_products]")}=last&${encodeURIComponent("resources[options][fields]")}=title,product_type,variants.title,vendor,body&section_id=predictive-search`).then(e=>{if(!e.ok){
        var t=new Error(e.status);
        throw this.close(),t}
        return e.text()}).then(e => {
          const s=(new DOMParser).parseFromString(e,"text/html").querySelector("#shopify-section-predictive-search").innerHTML;
          this.cachedResults[t]=s
          this.renderSearchResults(s)
       }).catch(e => {
    	  throw this.close(),e
       })
    }
  
    renderSearchResults(e){
    	this.predictiveSearchResults.innerHTML=e,this.updateCurrencies(),
    	this.setAttribute("results",!0),
    	this.open()
    }
  
    updateCurrencies(){
    	var e=$("#currency-list-header[name='dbtfy-custom-currencies']"),
    	t=theme.strings.shopCurrency;
    	e.length&&t&&Currency.currentCurrency&&Currency.convertAll(t,Currency.currentCurrency)
    }
  
    open() {
    	this.predictiveSearchResults.hidden=!1,this.setAttribute("open",!0),
    	this.input.setAttribute("aria-expanded",!0)
    } 
  
    close(e=!1) {
    	e&&(this.input.value="",this.removeAttribute("results"));
    	const t=this.querySelector(".item-selected");
    	t&&t.classList.remove("item-selected"),
    	this.input.setAttribute("aria-activedescendant",""),
    	this.predictiveSearchResults.hidden=!0,this.removeAttribute("open"),
    	this.input.setAttribute("aria-expanded",!1)
    }
}
customElements.define("predictive-search",PredictiveSearch);